module.exports = __webpack_public_path__ + "img/glassquality_5.19514a21.png";